import { RETAIL } from './constants/RequestedDataTypes';
import { createRequestTypes } from './helpers/RequestActions';
export const FetchRetailRequestTypes = createRequestTypes(RETAIL);